var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "Subheader",
        {
          attrs: {
            title: "Approval Level Tenant Configurations",
            search: "Approval Levels",
          },
          model: {
            value: _vm.approvalSearch,
            callback: function ($$v) {
              _vm.approvalSearch = $$v
            },
            expression: "approvalSearch",
          },
        },
        [
          _c(
            "v-btn",
            {
              attrs: { color: "add" },
              on: {
                click: function ($event) {
                  return _vm.addApprovalLevel()
                },
              },
            },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
              _vm._v("\n      " + _vm._s(_vm.$t("Button.Add")) + "\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-alert",
            {
              attrs: { outline: "", color: "info", value: true, icon: "info" },
            },
            [
              _vm._v(
                "\n      An approval level configuration maps a database approval level with custom client-facing text. "
              ),
              _c("code", [_vm._v("Continuous Database Value")]),
              _vm._v(
                " is the database approval level value targetted by this configuration. "
              ),
              _c("code", [_vm._v("Output Text")]),
              _vm._v(" is the approval level text displayed to clients. "),
              _c("code", [_vm._v("Output Description")]),
              _vm._v(
                " is the explanation text for the value in the approval level legend at the bottom of a report.\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.tenantApprovalLevelConfigurations,
              search: _vm.approvalSearch,
              pagination: _vm.pagination,
              loading: _vm.isLoading,
            },
            on: {
              "update:pagination": function ($event) {
                _vm.pagination = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "items",
                fn: function (props) {
                  return [
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(
                        _vm._s(
                          props.item.MappedValue
                            ? props.item.MappedValue
                            : _vm.$t("ContinuousApprovalLevelManage.default")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(_vm._s(props.item.OutputText)),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(_vm._s(props.item.OutputDescription)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "text-xs-left" },
                      [
                        _c(
                          "EditButton",
                          {
                            attrs: { small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.updateApprovalLevel(props.item)
                              },
                            },
                          },
                          [_vm._v("Edit")]
                        ),
                        _vm._v(" "),
                        _c(
                          "DeleteButton",
                          {
                            attrs: {
                              small: "",
                              loading: _vm.isBeingDeleted(props.item),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteApprovalLevel(props.item)
                              },
                            },
                          },
                          [_vm._v("Delete")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("UpsertApprovalLevelForm", {
        attrs: {
          approvalLevelConfiguration: _vm.approvalLevelConfigurationToUpdate,
          tenantId: _vm.tenantId,
        },
        model: {
          value: _vm.upsertApprovalLevelFormModal,
          callback: function ($$v) {
            _vm.upsertApprovalLevelFormModal = $$v
          },
          expression: "upsertApprovalLevelFormModal",
        },
      }),
      _vm._v(" "),
      _c("ConfirmationDialog2", { ref: "confirmationDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }